import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { addCyberSecurityCurriculamTimeline, addCuberSecuritySummit, getCyberSecurityCurriculamTimeline, getCyberSecuritySummit } from "./CyberSecuritySubtitlesApi";


const initialState: any = {
  loading: {
    add_summit: false,
    get_summit: false,
    add_timeline: false,
    get_timeline: false,
  },
  req_success: {
    add_summit: false,
    get_summit: false,
    add_timeline: false,
    get_timeline: false,
  },
  cyber_security_summit: {},
  cyber_security_timeline: {},
};

const CyberSecuritySubtitlesSlice = createSlice({
  name: "CyberSecuritySubtitlesSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    
    builder.addCase(addCuberSecuritySummit.pending, (state) => {
      state.loading.add_summit = true;
      state.req_success.add_summit = false;
    });
    builder.addCase(
      addCuberSecuritySummit.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add_summit = false;
        state.req_success.add_summit = true;
        state.cyber_security_summit = payload.data;
      }
    );
    builder.addCase(addCuberSecuritySummit.rejected, (state) => {
      state.loading.add_summit = false;
    });

    // getPDMSummit
    builder.addCase(getCyberSecuritySummit.pending, (state) => {
      state.loading.get_summit = true;
      state.req_success.get_summit = false;
      state.req_success.add_summit = false;
    });
    builder.addCase(
      getCyberSecuritySummit.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_summit = false;
        state.req_success.get_summit = true;
        state.req_success.add_summit = true;
        state.cyber_security_summit = payload.data;
      }
    );
    builder.addCase(getCyberSecuritySummit.rejected, (state) => {
      state.loading.get_summit = false;
      state.req_success.add_summit = false;
    });

    builder.addCase(addCyberSecurityCurriculamTimeline.pending, (state) => {
      state.loading.add_timeline = true;
      state.req_success.add_timeline = false;
    });
    builder.addCase(
      addCyberSecurityCurriculamTimeline.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.add_timeline = false;
        state.req_success.add_timeline = true;
        state.cyber_security_timeline = payload.data;
      }
    );
    builder.addCase(addCyberSecurityCurriculamTimeline.rejected, (state) => {
      state.loading.add_timeline = false;
    });

    builder.addCase(getCyberSecurityCurriculamTimeline.pending, (state) => {
      state.loading.get_timeline = true;
      state.req_success.get_timeline = false;
    });
    builder.addCase(
      getCyberSecurityCurriculamTimeline.fulfilled,
      (state, { payload }: PayloadAction<any>) => {
        state.loading.get_timeline = false;
        state.req_success.get_timeline = true;
        state.req_success.add_timeline = true;
        state.cyber_security_timeline = payload.data;
      }
    );
    builder.addCase(getCyberSecurityCurriculamTimeline.rejected, (state) => {
      state.loading.get_timeline = false;
    });
  },
});
export default CyberSecuritySubtitlesSlice.reducer;
